import { render, staticRenderFns } from "./RewardsId.vue?vue&type=template&id=125700f0&scoped=true"
import script from "./RewardsId.vue?vue&type=script&lang=js"
export * from "./RewardsId.vue?vue&type=script&lang=js"
import style0 from "./RewardsId.vue?vue&type=style&index=0&id=125700f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125700f0",
  null
  
)

export default component.exports